import { observer } from 'mobx-react-lite';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import * as React from 'react';
import {
    useLivePersonaCard,
    PersonaCardBehaviorProps,
} from 'owa-persona/lib/components/PersonaCardBehavior';

const searchBoxPillWellStyles = require('./SearchBoxPillWell.scss');

export interface PersonaPillProps extends PersonaCardBehaviorProps {
    isSelected: boolean;
}

export default observer(function PersonaPill(props: PersonaPillProps) {
    const PersonaCardBehavior = useLivePersonaCard(props);
    const pillDiv = React.useRef<HTMLDivElement | null>(null);
    React.useEffect(() => {
        if (props.isSelected && pillDiv.current) {
            pillDiv.current.focus();
        }
    });

    return (
        <PersonaCardBehavior>
            <div className={searchBoxPillWellStyles.personaPill} ref={pillDiv} tabIndex={-1}>
                <PersonaControl
                    name={props.name}
                    emailAddress={props.emailAddress}
                    size={PersonaSize.extraExtraSmall}
                    mailboxType={props.mailBoxType}
                />
                <div className={searchBoxPillWellStyles.personaPillNameText}>{props.name}</div>
            </div>
        </PersonaCardBehavior>
    );
});
